import React from 'react';

import InputTextField from '../../components/FormFields/InputTextField';
import { formClasses } from '../../utils/BEM';

export type CompleteNewPasswordFormData = { resetPassword: string };
type CompleteNewPasswordFormProps<T> = {
    busy: boolean;
    formData: T;
    setFormData: (formData: T) => void;
};

function CompleteNewPasswordForm<T extends CompleteNewPasswordFormData>({
    busy,
    formData,
    setFormData,
}: CompleteNewPasswordFormProps<T>) {
    return (
        <>
            <InputTextField
                autoComplete="current-password"
                label="New Password"
                name="password"
                type="password"
                value={formData.resetPassword}
                onChange={(resetPassword) =>
                    setFormData({
                        ...formData,
                        resetPassword,
                    })
                }
            />
            <div {...formClasses('fieldlike', undefined, 'text-end')}>
                <button {...formClasses('button')} disabled={busy}>
                    Set & Log In
                </button>
            </div>
        </>
    );
}

export default CompleteNewPasswordForm;
